module.exports = __webpack_public_path__ + "img/light-01.040e167b.png";